class CustomProductPrice extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.compare_container = this.querySelector(".product-price--compare"); // container for Was/Save
      this.price_el = this.querySelector(".product-price--original");
      this.money_format = this.getAttribute("data-money-format");
      this.reference_unit = this.querySelector(".product-price--reference-unit");
      this.reference_value = this.querySelector(".product-price--reference-value");
      this.unit_price = this.querySelector(".product-price--unit-price");
      this.unit_price_container = this.querySelector(".product-price--unit-container");
      this.saving_percent = this.querySelector(".product-price--percent-saving");
  
      this.updatePriceListener();
    }
  
    disconnectedCallback() {
      window.off(`theme:product:${this.dataset.id}:variantChanged.ProductPrice`);
    }
  
    updatePriceListener() {
      window.on(
        `theme:product:${this.dataset.id}:variantChanged.ProductPrice`,
        ({ detail: { variant } }) => this.updatePrices(variant)
      );
    }
  
    updatePrices(variant) {
      if (!variant) {
        this.parentNode.setAttribute("aria-hidden", true);
        return;
      }
  
      this.parentNode.setAttribute("aria-hidden", false);
  
      // Current price
      this.price_el.innerHTML = this.formatMoney(variant.price);
  
      // Compare, percent, and save
      const hasCompare =
        typeof variant.compare_at_price === "number" &&
        variant.compare_at_price > variant.price;
  
      if (hasCompare) {
        const saveAmount = variant.compare_at_price - variant.price;
        console.log('variant.compare_at_price', variant.compare_at_price, 'variant.price', variant.price, 'saveAmount', saveAmount); // Debugging line
        const pctOff = Math.floor(100 - (variant.price / variant.compare_at_price) * 100 + 0.5);
  
        // Badge text and visibility
        if (this.saving_percent) {
          this.saving_percent.textContent = `-${pctOff}%`;
          this.saving_percent.setAttribute("aria-label", `${pctOff} percent off`);
          this.saving_percent.style.display = "inline-block";
        }
  
        // Build the Was/Save markup just like Liquid
        const was = this.formatMoney(variant.compare_at_price);
        const save = this.formatMoney(saveAmount);
  
        this.compare_container.innerHTML = `
          <span style="opacity:.9;">
            Was: <span class="product-price--compare_value">${was}</span>
          </span>
          <span>Save: ${save}</span>
        `;
        this.compare_container.style.display = "inline-block";
      } else {
        if (this.saving_percent) this.saving_percent.style.display = "none";
        this.compare_container.style.display = "none";
        this.compare_container.innerHTML = ""; // clear any previous content
      }
  
      // Unit price
      if (variant.unit_price_measurement) {
        this.unit_price.innerHTML = this.formatMoney(variant.unit_price);
        this.reference_unit.innerHTML = variant.unit_price_measurement.reference_unit;
  
        if (variant.unit_price_measurement.reference_value === 1 && this.reference_value) {
          this.reference_value.style.display = "none";
        } else if (this.reference_value) {
          this.reference_value.innerHTML = variant.unit_price_measurement.reference_value;
          this.reference_value.style.display = "block";
        }
  
        this.unit_price_container.style.display = "flex";
      } else {
        this.unit_price_container.style.display = "none";
      }
    }
  
    formatMoney(cents) {
      const decimals = this.money_format.includes("no_decimals") ? 0 : 2;
      const locale = this.money_format.includes("comma") ? "de-DE" : "en-US";
      const formatted = Intl.NumberFormat(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(cents / 100);
  
      return this.money_format.replace(/\{\{\s*(\w+)\s*\}\}/, formatted);
    }
  }
  
  customElements.define("custom-product-price-element", CustomProductPrice);
  